// source: pushwoosh/applications_configurations/applications_configurations.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.displayName = 'proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    iosKeyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    iosTeamId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    iosBundleId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    iosAuthKey: msg.getIosAuthKey_asB64(),
    iosGateway: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIosKeyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIosTeamId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIosBundleId(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setIosAuthKey(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setIosGateway(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIosKeyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIosTeamId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIosBundleId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIosAuthKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getIosGateway();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional string ios_key_id = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.getIosKeyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.setIosKeyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ios_team_id = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.getIosTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.setIosTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ios_bundle_id = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.getIosBundleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.setIosBundleId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes ios_auth_key = 4;
 * @return {!(string|Uint8Array)}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.getIosAuthKey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes ios_auth_key = 4;
 * This is a type-conversion wrapper around `getIosAuthKey()`
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.getIosAuthKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getIosAuthKey()));
};


/**
 * optional bytes ios_auth_key = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getIosAuthKey()`
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.getIosAuthKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getIosAuthKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.setIosAuthKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional uint32 ios_gateway = 5;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.getIosGateway = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.prototype.setIosGateway = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    androidFramework: jspb.Message.getFieldWithDefault(msg, 1, ""),
    androidFcmServiceAccount: msg.getAndroidFcmServiceAccount_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAndroidFramework(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setAndroidFcmServiceAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAndroidFramework();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAndroidFcmServiceAccount_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string android_framework = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.prototype.getAndroidFramework = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.prototype.setAndroidFramework = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes android_fcm_service_account = 2;
 * @return {!(string|Uint8Array)}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.prototype.getAndroidFcmServiceAccount = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes android_fcm_service_account = 2;
 * This is a type-conversion wrapper around `getAndroidFcmServiceAccount()`
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.prototype.getAndroidFcmServiceAccount_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getAndroidFcmServiceAccount()));
};


/**
 * optional bytes android_fcm_service_account = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAndroidFcmServiceAccount()`
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.prototype.getAndroidFcmServiceAccount_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getAndroidFcmServiceAccount()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.prototype.setAndroidFcmServiceAccount = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    chromeFcmServiceAccount: msg.getChromeFcmServiceAccount_asB64(),
    chromeVapidKey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setChromeFcmServiceAccount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChromeVapidKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChromeFcmServiceAccount_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getChromeVapidKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bytes chrome_fcm_service_account = 1;
 * @return {!(string|Uint8Array)}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.prototype.getChromeFcmServiceAccount = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes chrome_fcm_service_account = 1;
 * This is a type-conversion wrapper around `getChromeFcmServiceAccount()`
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.prototype.getChromeFcmServiceAccount_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getChromeFcmServiceAccount()));
};


/**
 * optional bytes chrome_fcm_service_account = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChromeFcmServiceAccount()`
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.prototype.getChromeFcmServiceAccount_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getChromeFcmServiceAccount()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.prototype.setChromeFcmServiceAccount = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string chrome_vapid_key = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.prototype.getChromeVapidKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.prototype.setChromeVapidKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailFromName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    emailFromEmail: jspb.Message.getFieldWithDefault(msg, 2, ""),
    emailReplyName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    emailReplyEmail: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailFromName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailFromEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailReplyName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailReplyEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailFromName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmailFromEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmailReplyName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmailReplyEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string email_from_name = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.getEmailFromName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.setEmailFromName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email_from_email = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.getEmailFromEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.setEmailFromEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email_reply_name = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.getEmailReplyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.setEmailReplyName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email_reply_email = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.getEmailReplyEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.prototype.setEmailReplyEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    xiaomiAppId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    xiaomiAppSecret: jspb.Message.getFieldWithDefault(msg, 2, ""),
    xiaomiAppRegion: jspb.Message.getFieldWithDefault(msg, 3, ""),
    xiaomiAppPackageName: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setXiaomiAppId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setXiaomiAppSecret(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setXiaomiAppRegion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setXiaomiAppPackageName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getXiaomiAppId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getXiaomiAppSecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getXiaomiAppRegion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getXiaomiAppPackageName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string xiaomi_app_id = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.getXiaomiAppId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.setXiaomiAppId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string xiaomi_app_secret = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.getXiaomiAppSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.setXiaomiAppSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string xiaomi_app_region = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.getXiaomiAppRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.setXiaomiAppRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string xiaomi_app_package_name = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.getXiaomiAppPackageName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.prototype.setXiaomiAppPackageName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    huaweiAndroidFramework: jspb.Message.getFieldWithDefault(msg, 1, ""),
    huaweiAndroidAppId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    huaweiAndroidAppSecret: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHuaweiAndroidFramework(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHuaweiAndroidAppId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHuaweiAndroidAppSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHuaweiAndroidFramework();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHuaweiAndroidAppId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHuaweiAndroidAppSecret();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string huawei_android_framework = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.prototype.getHuaweiAndroidFramework = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.prototype.setHuaweiAndroidFramework = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string huawei_android_app_id = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.prototype.getHuaweiAndroidAppId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.prototype.setHuaweiAndroidAppId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string huawei_android_app_secret = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.prototype.getHuaweiAndroidAppSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.prototype.setHuaweiAndroidAppSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    safariWebsiteName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    safariWebsiteIcon: msg.getSafariWebsiteIcon_asB64(),
    safariAllowedDomainsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    safariUrlTemplate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    safariKeyFile: msg.getSafariKeyFile_asB64(),
    safariCertPassword: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSafariWebsiteName(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSafariWebsiteIcon(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSafariAllowedDomains(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSafariUrlTemplate(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSafariKeyFile(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSafariCertPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSafariWebsiteName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSafariWebsiteIcon_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getSafariAllowedDomainsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getSafariUrlTemplate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSafariKeyFile_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      5,
      f
    );
  }
  f = message.getSafariCertPassword();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string safari_website_name = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariWebsiteName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.setSafariWebsiteName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes safari_website_icon = 2;
 * @return {!(string|Uint8Array)}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariWebsiteIcon = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes safari_website_icon = 2;
 * This is a type-conversion wrapper around `getSafariWebsiteIcon()`
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariWebsiteIcon_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSafariWebsiteIcon()));
};


/**
 * optional bytes safari_website_icon = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSafariWebsiteIcon()`
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariWebsiteIcon_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSafariWebsiteIcon()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.setSafariWebsiteIcon = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * repeated string safari_allowed_domains = 3;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariAllowedDomainsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.setSafariAllowedDomainsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.addSafariAllowedDomains = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.clearSafariAllowedDomainsList = function() {
  return this.setSafariAllowedDomainsList([]);
};


/**
 * optional string safari_url_template = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariUrlTemplate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.setSafariUrlTemplate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bytes safari_key_file = 5;
 * @return {!(string|Uint8Array)}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariKeyFile = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes safari_key_file = 5;
 * This is a type-conversion wrapper around `getSafariKeyFile()`
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariKeyFile_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSafariKeyFile()));
};


/**
 * optional bytes safari_key_file = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSafariKeyFile()`
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariKeyFile_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSafariKeyFile()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.setSafariKeyFile = function(value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};


/**
 * optional string safari_cert_password = 6;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.getSafariCertPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.prototype.setSafariCertPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    wnsPsid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    wnsSecret: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWnsPsid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWnsSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWnsPsid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWnsSecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string wns_psid = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.prototype.getWnsPsid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.prototype.setWnsPsid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string wns_secret = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.prototype.getWnsSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.prototype.setWnsSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    admCid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    admSecret: jspb.Message.getFieldWithDefault(msg, 2, ""),
    admFramework: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration;
  return proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdmCid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdmSecret(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdmFramework(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdmCid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdmSecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAdmFramework();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string adm_cid = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.prototype.getAdmCid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.prototype.setAdmCid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string adm_secret = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.prototype.getAdmSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.prototype.setAdmSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string adm_framework = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.prototype.getAdmFramework = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.prototype.setAdmFramework = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_ = [[2,3,4,5,6,7,8,9,10]];

/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.KindCase = {
  KIND_NOT_SET: 0,
  IOS_TOKEN_CONFIGURATION: 2,
  ANDROID_CONFIGURATION: 3,
  CHROME_CONFIGURATION: 4,
  EMAIL_CONFIGURATION: 5,
  XIAOMI_CONFIGURATION: 6,
  HUAWEI_CONFIGURATION: 7,
  SAFARI_CONFIGURATION: 8,
  WINDOWS_CONFIGURATION: 9,
  AMAZON_CONFIGURATION: 10
};

/**
 * @return {proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.KindCase}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    iosTokenConfiguration: (f = msg.getIosTokenConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.toObject(includeInstance, f),
    androidConfiguration: (f = msg.getAndroidConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.toObject(includeInstance, f),
    chromeConfiguration: (f = msg.getChromeConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.toObject(includeInstance, f),
    emailConfiguration: (f = msg.getEmailConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.toObject(includeInstance, f),
    xiaomiConfiguration: (f = msg.getXiaomiConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.toObject(includeInstance, f),
    huaweiConfiguration: (f = msg.getHuaweiConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.toObject(includeInstance, f),
    safariConfiguration: (f = msg.getSafariConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.toObject(includeInstance, f),
    windowsConfiguration: (f = msg.getWindowsConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.toObject(includeInstance, f),
    amazonConfiguration: (f = msg.getAmazonConfiguration()) && proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest;
  return proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.deserializeBinaryFromReader);
      msg.setIosTokenConfiguration(value);
      break;
    case 3:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.deserializeBinaryFromReader);
      msg.setAndroidConfiguration(value);
      break;
    case 4:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.deserializeBinaryFromReader);
      msg.setChromeConfiguration(value);
      break;
    case 5:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.deserializeBinaryFromReader);
      msg.setEmailConfiguration(value);
      break;
    case 6:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.deserializeBinaryFromReader);
      msg.setXiaomiConfiguration(value);
      break;
    case 7:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.deserializeBinaryFromReader);
      msg.setHuaweiConfiguration(value);
      break;
    case 8:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.deserializeBinaryFromReader);
      msg.setSafariConfiguration(value);
      break;
    case 9:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.deserializeBinaryFromReader);
      msg.setWindowsConfiguration(value);
      break;
    case 10:
      var value = new proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.deserializeBinaryFromReader);
      msg.setAmazonConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIosTokenConfiguration();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getAndroidConfiguration();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getChromeConfiguration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getEmailConfiguration();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getXiaomiConfiguration();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getHuaweiConfiguration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getSafariConfiguration();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getWindowsConfiguration();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getAmazonConfiguration();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional IOSTokenConfiguration ios_token_configuration = 2;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getIosTokenConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration, 2));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.IOSTokenConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setIosTokenConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearIosTokenConfiguration = function() {
  return this.setIosTokenConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasIosTokenConfiguration = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AndroidConfiguration android_configuration = 3;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getAndroidConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration, 3));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.AndroidConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setAndroidConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearAndroidConfiguration = function() {
  return this.setAndroidConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasAndroidConfiguration = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ChromeConfiguration chrome_configuration = 4;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getChromeConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration, 4));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.ChromeConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setChromeConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearChromeConfiguration = function() {
  return this.setChromeConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasChromeConfiguration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional EmailConfiguration email_configuration = 5;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getEmailConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration, 5));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.EmailConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setEmailConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearEmailConfiguration = function() {
  return this.setEmailConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasEmailConfiguration = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional XiaomiConfiguration xiaomi_configuration = 6;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getXiaomiConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration, 6));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.XiaomiConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setXiaomiConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearXiaomiConfiguration = function() {
  return this.setXiaomiConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasXiaomiConfiguration = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional HuaweiConfiguration huawei_configuration = 7;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getHuaweiConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration, 7));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.HuaweiConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setHuaweiConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearHuaweiConfiguration = function() {
  return this.setHuaweiConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasHuaweiConfiguration = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SafariConfiguration safari_configuration = 8;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getSafariConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration, 8));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.SafariConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setSafariConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearSafariConfiguration = function() {
  return this.setSafariConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasSafariConfiguration = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional WindowsConfiguration windows_configuration = 9;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getWindowsConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration, 9));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.WindowsConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setWindowsConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearWindowsConfiguration = function() {
  return this.setWindowsConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasWindowsConfiguration = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional AmazonConfiguration amazon_configuration = 10;
 * @return {?proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.getAmazonConfiguration = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration, 10));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications_configurations.AmazonConfiguration|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
*/
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.setAmazonConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.clearAmazonConfiguration = function() {
  return this.setAmazonConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationRequest.prototype.hasAmazonConfiguration = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse;
  return proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.ConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    platform: jspb.Message.getFieldWithDefault(msg, 2, 0),
    enable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest;
  return proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPlatform(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 platform = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.prototype.getPlatform = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool enable = 3;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformRequest.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse;
  return proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications_configurations.EnablePlatformResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.applications_configurations);
